import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ServiceProvider, ServiceProviderFactory } from '@union-investment-b2b-portal/service-provider';
import { TrackService } from '@union-investment-b2b-portal/tracking-service';
import { PageTrackingEvent } from '@union-investment-b2b-portal/tracking-service/build/release/types/_external/ui-frontend/packages/libs/tracking/src/events';
import { TRACK_SERVICE_KEY } from '@union-investment-b2b-portal/tracking-service/constants'; 
import { AuthInterceptor } from 'src/app/common/interceptors/auth.interceptor';
import { LOG } from 'src/app/common/util/log';

@Injectable({
  providedIn: 'root'
})
export class CustomTrackingService {
  private readonly httpInterceptors = inject(HTTP_INTERCEPTORS);

  private serviceProvider: ServiceProvider | undefined;
  private trackService: TrackService | undefined;
  private readonly auth?: AuthInterceptor = this.httpInterceptors.find(
    interceptor => interceptor instanceof AuthInterceptor
  ) as AuthInterceptor | undefined;

  constructor() { 
    this.initTrackService();
  }

  private initTrackService() {
    try {
      const serviceProviderHost: HTMLElement = document.querySelector('#root') as HTMLElement;
      this.serviceProvider = ServiceProviderFactory.getServiceProvider({
        mountOptions: { element: serviceProviderHost },
      });

      this.trackService = this.serviceProvider.getService<TrackService>(TRACK_SERVICE_KEY);
    } catch (e) {
      LOG.warn(e);
    }
  }

  public async runTracking(trackEventConfig: PageTrackingEvent): Promise<void> {
    try {
      const [user, loggedIn] = await Promise.all([
        this.auth.getLoginService()?.getUserData(),
        this.auth.getLoginService()?.isAuthenticated(),
      ]);
      const userRoles = user?.profile['roles'] as string[];
      const userRolesString = userRoles.join(', ');

      trackEventConfig.attributes.customSessionParameter[2] = loggedIn ? 'logged in' : 'logged out';
      trackEventConfig.attributes.customSessionParameter[7] = user ? userRolesString : undefined;
      
      this.trackService?.track(trackEventConfig);
    } catch(e) {
      LOG.error(e);
    }
  }
}
